import { useProductPageContext } from '../../productPageContext'

type ProductStockStatus = {
  color: string
  message: string | null
}

enum PRODUCT_STOCK_INFORMATION_STATUS_ENUM {
  NOW_SHIPPING_AVAILABLE = 'now_shipping_available',
  OUT_OF_STOCK = 'out_of_stock',
  SHIP_IN_FOUR_SIX_DAYS = 'ship_in_four_six_days',
  SHIP_IN_ONE_DAY = 'ship_in_one_day',
  SHIP_IN_TWO_THREE_DAYS = 'ship_in_two_three_days',
  SHIP_UPON_ARRIVAL = 'ship_upon_arrival',
  SHIPPABLE = 'shippable',
}

const PRODUCT_STOCK_STATUS_DEFAULT = { color: '', message: null }
const stockStatusMap: Record<
  PRODUCT_STOCK_INFORMATION_STATUS_ENUM,
  ProductStockStatus
> = {
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.NOW_SHIPPING_AVAILABLE]: {
    color: 'text-dark-success',
    message: 'NOW! Verfügbar',
  },
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.OUT_OF_STOCK]: {
    color: 'text-dark-brand-medium',
    message: 'Produkt vorübergehend nicht lieferbar',
  },
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.SHIP_IN_FOUR_SIX_DAYS]: {
    color: 'text-dark-success',
    message: 'Versand in 4-6 Tagen',
  },
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.SHIP_IN_ONE_DAY]: {
    color: 'text-dark-success',
    message: 'Versandbereit',
  },
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.SHIP_IN_TWO_THREE_DAYS]: {
    color: 'text-dark-success',
    message: 'Versand in 2-3 Tagen',
  },
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.SHIP_UPON_ARRIVAL]: {
    color: 'text-dark-note',
    message: 'Versand bei Wareneingang',
  },
  [PRODUCT_STOCK_INFORMATION_STATUS_ENUM.SHIPPABLE]: {
    color: 'text-dark-success',
    message: 'Lieferbar',
  },
}

/**
 * Checks the bestLeadTime & Inventory of the current offer, figures out the color and message to display and returns it
 */
export const useProductStockInformationStatus = (): ProductStockStatus => {
  const { currentOffer } = useProductPageContext()

  // if not sellable => show out of stock message
  if (!currentOffer) {
    return stockStatusMap[PRODUCT_STOCK_INFORMATION_STATUS_ENUM.OUT_OF_STOCK]
  }

  return PRODUCT_STOCK_STATUS_DEFAULT
}
